import React from "react";
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import {unlockPricing} from "../../../actions/actionFunctions";
import Analytics from "../../../analytics";

class FeatureInfoPriceLocked extends React.Component {

  static propTypes = {
    textOnly: PropTypes.bool
  }

  handlePriceLockClick = () => {
    Analytics.sendClickEvent('feature-info-price-unlock');
    this.props.unlockPricing();
  };

  render() {
    return this.props.textOnly ? (
      <span className="price price--locked" onClick={this.handlePriceLockClick}>
        <FormattedMessage id="quotingTool.featureInfo.priceLockedTitle"/>
      </span>
    ) : (
      <button className="product-info__price-locked bold" onClick={this.handlePriceLockClick}>
        <span className="product-info__price-locked-title">
          <FormattedMessage id="quotingTool.featureInfo.priceLockedTitle"/>
        </span>
        <span className="product-info__price-locked-subtitle">
          <FormattedMessage id="quotingTool.featureInfo.priceLockedSubTitle"/>
        </span>
      </button>
    )
  }
}

const mapStateToProps = () => {
  return {
  };
};

export default connect(mapStateToProps, {
  unlockPricing
})(FeatureInfoPriceLocked);
